module.exports = __webpack_public_path__ + "img/logo_alembic_pharmaceuticals.5dd6be91.png";